/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Genre_RomanceInputs */

const en_onboarding_genre_romance = /** @type {(inputs: Onboarding_Genre_RomanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Romance`)
};

const es_onboarding_genre_romance = /** @type {(inputs: Onboarding_Genre_RomanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Romance`)
};

/**
* | output |
* | --- |
* | "Romance" |
*
* @param {Onboarding_Genre_RomanceInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_genre_romance = /** @type {((inputs?: Onboarding_Genre_RomanceInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Genre_RomanceInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_genre_romance(inputs)
	return en_onboarding_genre_romance(inputs)
});